<template>
  <f7-page>
    <navbar :text="$t('Monitoring_pests_navbar_title')" />
    <DxMonitoringPests :key-name="'monitoringPests'" />
  </f7-page>
</template>

<script>
import DxMonitoringPests from '../../components/scouting/DxMonitoringPests.vue';
import navbar from '../../components/NavBar.vue';

export default {
  name: 'MonitoringPests',
  components: {
    DxMonitoringPests,
    navbar,
  },
};
</script>
